import { Sparkles, Camera, Mic, PenLine, Brain } from "lucide-react";

const SOURCE_META = {
  photo: { icon: Camera, label: "Photo Receipt", accent: "#FF9500" },
  voice: { icon: Mic, label: "Voice Note", accent: "#34D399" },
  manual: { icon: PenLine, label: "Manual Entry", accent: "#FBBF24" },
};

export function confMeta(pct) {
  const n = Number(pct) || 0;
  if (n >= 90) return { label: "High", cls: "text-[#34D399] border-[#34D399]/30 bg-[#34D399]/10", bar: "#34D399" };
  if (n >= 70) return { label: "OK", cls: "text-[#FBBF24] border-[#FBBF24]/30 bg-[#FBBF24]/10", bar: "#FBBF24" };
  if (n > 0) return { label: "Low", cls: "text-[#F87171] border-[#F87171]/30 bg-[#F87171]/10", bar: "#F87171" };
  return null;
}

export default function AISummaryCard({ source, form, twin, filledCount, netAmount }) {
  const meta = SOURCE_META[source] || SOURCE_META.manual;
  const SrcIcon = meta.icon;
  const conf = form.confidence || {};
  const overall = Number(conf.overall) || 0;
  const overallMeta = confMeta(overall);

  return (
    <div className="bi-surface p-4 relative overflow-hidden" data-testid="rv-ai-summary">
      <div
        className="absolute -top-24 -right-24 w-56 h-56 rounded-full blur-3xl opacity-25"
        style={{ background: meta.accent }}
      />
      <div className="relative flex items-start gap-3">
        <div
          className="w-10 h-10 rounded-xl flex items-center justify-center"
          style={{ background: `${meta.accent}20`, color: meta.accent }}
        >
          <SrcIcon className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <div className="text-[10px] uppercase tracking-[0.2em] text-white/50 font-heading">Source</div>
            <div className="text-sm font-semibold" style={{ color: meta.accent }}>
              {meta.label}
            </div>
            {twin && (
              <span
                data-testid="rv-twin-badge"
                className="text-[10px] px-2 py-0.5 rounded-full border border-[#34D399]/40 bg-[#34D399]/10 text-[#34D399] font-heading uppercase tracking-wider inline-flex items-center gap-1"
              >
                <Brain className="w-3 h-3" /> Twin · {twin.history_count}×
              </span>
            )}
          </div>
          <div className="mt-1 flex items-baseline gap-2">
            <Sparkles className="w-3.5 h-3.5 text-[#FF9500]" />
            <div className="text-sm text-white/80">AI confidence</div>
            {overallMeta ? (
              <span className={`text-[10px] px-2 py-0.5 rounded-full border ${overallMeta.cls}`}>
                {overallMeta.label} · {overall}%
              </span>
            ) : (
              <span className="text-[10px] px-2 py-0.5 rounded-full bi-chip">Manual</span>
            )}
          </div>
          <div className="mt-2 h-1.5 rounded-full bg-white/5 overflow-hidden">
            <div
              className="h-full transition-all duration-500"
              style={{ width: `${overall}%`, background: overallMeta?.bar || "#6B7280" }}
            />
          </div>
          {twin && twin.filled && twin.filled.length > 0 && (
            <div className="mt-2 text-[11px] text-[#34D399]">
              Twin auto-filled: <b>{twin.filled.map((f) => f.replace("_", " ")).join(", ")}</b>{" "}
              based on {twin.history_count} past entries with &ldquo;{twin.matched_supplier}&rdquo;.
            </div>
          )}
        </div>
      </div>
      <div className="relative mt-3 grid grid-cols-3 gap-2 text-center">
        <div className="bi-surface-2 py-2 rounded-lg">
          <div className="text-[10px] uppercase tracking-wider text-white/50">Fields filled</div>
          <div className="font-heading font-extrabold text-lg">{filledCount}/5</div>
        </div>
        <div className="bi-surface-2 py-2 rounded-lg">
          <div className="text-[10px] uppercase tracking-wider text-white/50">Net</div>
          <div className="font-heading font-extrabold text-lg">${netAmount.toFixed(2)}</div>
        </div>
        <div className="bi-surface-2 py-2 rounded-lg">
          <div className="text-[10px] uppercase tracking-wider text-white/50">GST</div>
          <div className="font-heading font-extrabold text-lg text-[#FF9500]">
            ${(Number(form.gst) || 0).toFixed(2)}
          </div>
        </div>
      </div>
    </div>
  );
}
